import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PrintTicketsBase } from './PrintTickets'

import { dataSelector } from 'reduxModules/selectors/ModalSelectors'

const mapStateToProps = createStructuredSelector({
  data: dataSelector
})

export const PrintTickets = connect(mapStateToProps)(PrintTicketsBase)



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintTickets/index.js